import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import InfoIcon from '../../Common/InfoIcon/InfoIcon';
import React from 'react';
import MatchingKey from '../../../types/report/MatchingKey';
import ComponentChangeLogIconAndAction from '../../Common/Modals/ComponentChangeLogModal/ComponentChangeLogIconAndAction';
import ComponentType from '../../../types/report/ComponentType';

const getColumns = (matchingKeyData: { name: string, type: string, info: string, componentType: ComponentType }, reportConfigId: number): ColumnDefinition<MatchingKey>[] => {

    let columns: ColumnDefinition<MatchingKey>[] = [
        {
            header: 'Info',
            getContent: () => <InfoIcon info={matchingKeyData.info} isSmallSize={true} />,
            width: '20%'
        },
        {
            header: 'Name',
            getContent: () => matchingKeyData.name,
            className: 'break-all',
            width: '40%'
        },
        {
            header: 'Data Type',
            getContent: () => matchingKeyData.type,
            width: '30%'
        },
        {
            header: '',
            getContent: () => <div className='display-flex justify-content-end'>
                <ComponentChangeLogIconAndAction
                    reportConfigId={reportConfigId}
                    id={0}
                    componentName={matchingKeyData.name}
                    componentType={matchingKeyData.componentType} />
            </div>,
            width: '10%'
        }
    ];

    return columns;
};

export { getColumns };